import { render, staticRenderFns } from "./PrivacyContract-05-2022.vue?vue&type=template&id=540f8bbe&scoped=true"
import script from "./PrivacyContract-05-2022.vue?vue&type=script&lang=js"
export * from "./PrivacyContract-05-2022.vue?vue&type=script&lang=js"
import style0 from "./PrivacyContract-05-2022.vue?vue&type=style&index=0&id=540f8bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f8bbe",
  null
  
)

export default component.exports